import { ReactNode } from "react";
import styled from "styled-components";
import { lang } from "../assets/languages/en.language";
import { theme } from "../configs/theme";
import { usePwaViewportWidth } from "../hooks/useScreenWidth";
import { getBackgroundColor } from "../services/utils";
import { TertiaryFitContentButton } from "../styles/Button.style";
import { Column, Gap } from "../styles/Utils";

export const ReadAndConfirmModal = ({
  setWarningOpen,
  children,
  routeName,
}: {
  setWarningOpen: (bool: boolean) => void;
  children: ReactNode;
  routeName: string;
}) => {
  const screenWidth = usePwaViewportWidth();

  return (
    <Overlay $width={screenWidth} $backgroungColor={getBackgroundColor(routeName, theme)}>
      {children}
      <Gap $height={2.5} />
      <TertiaryFitContentButton onClick={() => setWarningOpen(false)}>
        <span>{lang.buttons.next}</span>
      </TertiaryFitContentButton>
      <Gap $height={2} />
    </Overlay>
  );
};

const Overlay = styled(Column)<{ $backgroungColor: string; $width: number }>`
  position: fixed;
  z-index: 1;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: ${(props) => props.$width + "px"};
  height: 100%;
  background: ${(props) => props.$backgroungColor};
  align-items: center;
  overflow-y: auto;
`;
